const language = 'brasil';
export const langDir = 'ltr';

export default language;
